import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

export type CancellationPolicy = {
  EndDate: string;
  StartDate: string;
  Value: Value;
};

export type Value = {
  Value: string;
};

export type SellingPrice = {
  Value: string;
};

type CancellationPolicies = {
  end_date: string;
  start_date: string;
  value: number;
}

export type Root = {
  check_in: string;
  check_in_hour: string;
  check_out: string;
  check_out_hour: string;
  city: string;
  hotel_address: string;
  hotel_name: string;
  hotel_id: number;
  room_description: string;
  observations: string;
  price: number;
  reservation_id: number;
  reservation_date: string;
  service_id: number;
  id: string;
  status: string;
  voucher_url: string;
  details?: string;
  cancellation_policies: CancellationPolicies
  cashback?: number;
};

export const fetchBookingDone = async (bookingId: string) => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }
  const response = await fetch(`${BASE_URL_API}/bookings/${bookingId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
  });

  const { details, ...rest } = (await response.json()) as Root;

  if (response.status !== 200) {
    throw new Error(details);
  }
  return rest;
};
